
// import closeIcon from "../../../src/assets/images/Icons/close_icon.svg";

import UseBodyScrollLock from "./UseBodyScrollLock";
function ErrorInnerPopup({ onCloseModal, closeButton = true, modalHeader = false, modalTitle = "message", children }) {
    const showModal = true;

    const handleModalClose = () => {
        onCloseModal()
    }
    const handleOverlayClick = (event) => {
        event.stopPropagation(); // Stop propagation to prevent clicks outside the modal
        onCloseModal();
    };
    UseBodyScrollLock(showModal)
    return (
        <>
            {
                showModal &&
                <>
                    <div className="errormodal_overlay"> </div>
                    <div className="errormodal">
                        {
                            modalHeader && (<div className="errormodal_header">
                                {modalTitle ? <p>{modalTitle}</p> : ""}
                                {modalTitle ? <div className="errorheader_bottom_border"></div> : ""}
                            </div>)
                        }
                        {
                            closeButton ? <div className="errormodal_close" onClick={handleModalClose}>
                                {/* <img src={closeIcon} alt="" /> */}
                            </div> : ""
                        }

                        <div className="errormodal_body">
                            {children}
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default ErrorInnerPopup